import { ControlModel } from "../models/index";
import { ControlTypeEnum } from "../abstraction";

export class Utils {
	// generates a new Universally unique identify (UUID) 
	// the UUID is used to identify each of the tasks
	public static uuid(): string {
		/*jshint bitwise:false */
		var i, random;
		var uuid = '';

		for (i = 0; i < 32; i++) {
			random = Math.random() * 16 | 0;
			if (i === 8 || i === 12 || i === 16 || i === 20) {
				uuid += '-';
			}
			uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random))
				.toString(16);
		}

		return uuid;
	}

	public static decodeInlineStyleFromJson(style: string): object {
		let inlineStyle = {};
		if (style) {
			try {
				inlineStyle = JSON.parse(style);
			}
			catch (err) {
				console.debug(err);
				console.debug(style);
			}
		}
		return inlineStyle;
	}


	// Retourne une chaine contenant les classes bootstrap col-**-* selon la largeur du champ
	// Gestion des tailles des controles :
	// 1 = 25% de la largeur 
	// 2 = 50%
	// 3 = 75%
	// 4 = 100%
	public static getColSizeClasses(ctrl: ISizable): string {
		// En mode XS, la taille de chaque controle est par défaut de 100%
		let colSizeXS = 4;

		// Si une classe spécifie une taille, alors inutile de s'en occuper
		if (ctrl.Class) {
			if ((" " + ctrl.Class.toUpperCase()).indexOf(" COL-") != -1) {
				return "";
			}
		}
		// En mode LG, la taille de chaque controle est par défaut de 50%
		let colSizeLG = 2;

		switch (ctrl.bsSize ? ctrl.bsSize : "auto") {
			case "1":
				colSizeXS = 6
				colSizeLG = 3;
				break;
			case "2":
				colSizeXS = 6
				colSizeLG = 4;
				break;
			case "3":
				colSizeXS = 12
				colSizeLG = 6;
				break;
			case "4":
				colSizeXS = 12
				colSizeLG = 12;
				break;
			case "auto":
				// Longueur max du champ
				let maxLen = 20;    // Valeur par défaut
				if (ctrl.MaxLength) {
					if (ctrl.MaxLength > maxLen) maxLen = ctrl.MaxLength;
				}
				if (ctrl.ControlType == ControlTypeEnum.label) {
					if (ctrl.Value.length) maxLen = ctrl.Value.length;
				}

				if (ctrl.Description) {
					if (ctrl.Description.length > maxLen) maxLen = ctrl.Description.length/2;
				}

				colSizeXS = Math.round((maxLen) / 10) * 2;

				if (colSizeXS < 6) colSizeXS = 6
				else colSizeXS = 12;

				colSizeLG = Math.round(maxLen / 10) * 2;

				if (colSizeLG < 4) colSizeLG = 4
				if (colSizeLG > 12) colSizeLG = 12;
				break;
			default:
				colSizeXS = 6;
				colSizeLG = 4;
				break;
		}

		let xs = `col-${colSizeXS} `;
		let lg = `col-lg-${colSizeLG} `;

		return xs + lg;
	}

	public static textToChars = (text) => text.split('').map(c => c.charCodeAt(0));
	public static charToHex = (n) => ("0" + Number(n).toString(16)).substr(-2);
	public static stringToHex = (text) => text.split('').map(t => Utils.textToChars(t)).map(t => Utils.charToHex(t)).join('');
	public static hexToString = (text) => text.match(/.{1,2}/g).map(hex => parseInt(hex, 16)).map(charCode => String.fromCharCode(charCode)).join('');
}

export interface ISizable {
	Class: string;
	MaxLength: number;
	bsSize: string;
	Value: string;
	Description: string;
	ControlType: ControlTypeEnum;
}


// Gestionnaire d'évènements
export class KEvent<T> {
	public EventHandlers: { (data: T) : boolean }[] = [];

	// Ajoute un nouveau vecteur de traitement pour cet évènement
	// Attention à systématiquement appeler reset entre chaque page pour vider cette liste
	// 
	public add(handler: { (data: T) }) {
		//this.EventHandlers = [];
		this.EventHandlers.push(handler);
	}

	public reset() {
		this.EventHandlers = [];
	}

	// Si le handler retourne true => cancel => on ne déclenche pas les suivants
	public trigger(data: T) {
		try {
			let i = this.EventHandlers.length;
			while (i-- > 0) if (this.EventHandlers[i](data) == true)  return;
		}
		catch (err) {
			console.error(err);
		}
	}


}